<template>
    <v-container fluid grid-list-md v-if="!loading">
        <v-layout row wrap justify-center>
            <v-flex xs12 v-for="env in environment" :key="env.key">
                <v-text-field
                        :label="env.label"
                        :disabled="saving"
                        v-model="env.value"
                        @keyup.enter="submit"
                ></v-text-field>
            </v-flex>
            <v-flex xs12>
                <v-btn @click="submit" :disabled="saving" :loading="saving" block>{{ $t('save') }}</v-btn>
            </v-flex>
        </v-layout>
    </v-container>
    <v-progress-circular v-else indeterminate color="primary"></v-progress-circular>
</template>

<script>
    import Vue from 'vue';

    export default {
        data: () => ({
            loading: false,
            saving: false,
            environment: []
        }),
        mounted() {
            if (this.loading) {
                return;
            }

            this.loading = true;

            axios.get('/api/v1/environment').then(response => {
                if (!response.data.success) {
                    return;
                }

                Vue.set(this, 'environment', response.data.data);

                this.loading = false;
            });
        },
        methods: {
            submit() {
                if (this.saving) {
                    return;
                }

                this.saving = true;

                axios.post('/api/v1/environment', {env: this.environment}).then(response => {
                    if (!response.data.success) {
                        this.$store.commit('snackBar', {
                            color: 'error',
                            text: 'Umgebung konnte nicht gespeichert werden'
                        });
                        return;
                    }

                    this.$store.commit('snackBar', {
                        color: 'success',
                        text: 'Umgebung erfolgreich gespeichert'
                    });
                    this.saving = false;
                });
            }
        }
    }
</script>
